import { useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import QuoteForm from "./QuoteForm";
import { track } from "../../lib/analytics";

export default function QuoteDialog({ open, onOpenChange, product }) {
  const name = typeof product === "string" ? product : product?.name || "";
  const sku = typeof product === "object" ? product?.sku || "" : "";

  useEffect(() => {
    if (open) track("Quote Form Opened", { product: name || "general", sku });
  }, [open, name, sku]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="w-screen sm:w-full sm:max-w-2xl h-[100dvh] sm:h-auto max-h-[100dvh] sm:max-h-[92vh] top-0 sm:top-[50%] translate-y-0 sm:translate-y-[-50%] rounded-none sm:rounded-2xl overflow-y-scroll overscroll-contain touch-pan-y p-0 gap-0"
        style={{ WebkitOverflowScrolling: "touch" }}
        data-lenis-prevent="true"
        data-testid="quote-dialog"
      >
        <div className="h-1.5 w-full bg-[#FDCD00] sm:rounded-t-2xl" />
        <div className="p-6 md:p-8 pb-[max(2rem,env(safe-area-inset-bottom))]">
          <DialogHeader>
            <DialogTitle className="font-head text-2xl text-[#0A1C0E]">Request a Quote</DialogTitle>
            <DialogDescription className="text-[#3A4D3E] text-sm">
              {name
                ? `Fill in a few details for ${name} and we'll continue on WhatsApp with your quote.`
                : "Fill in a few details and we'll continue on WhatsApp with your quote."}
            </DialogDescription>
          </DialogHeader>
          <div className="mt-5">
            <QuoteForm defaultProduct={name} defaultSku={sku} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
